export const presetColors = [
  "#dc2626",
  "#b91c1c",
  "#c2410c",
  "#ea580c",
  "#d97706",
  "#a16207",
  "#4d7c0f",
  "#16a34a",
  "#166534",
  "#0f766e",
  "#0891b2",
  "#2563eb",
  "#1e40af",
  "#4338ca",
  "#7c3aed",
  "#a21caf",
];

export function randomPresetColor() {
  return presetColors[Math.floor(Math.random() * presetColors.length)];
}

export function hexToHSL(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  let r = parseInt(result[1], 16);
  let g = parseInt(result[2], 16);
  let b = parseInt(result[3], 16);
  r = r / 255;
  g = g / 255;
  b = b / 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h = h / 6;
  }
  var HSL = {
    h: h,
    s: s,
    l: l,
  };

  return HSL;
}
